import { render, staticRenderFns } from "./CertificationEditor.vue?vue&type=template&id=56bd1212&"
import script from "./CertificationEditor.vue?vue&type=script&lang=js&"
export * from "./CertificationEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports